import { MULTISTOP_IATA_LIST_SEPARATOR, PARAM_LIST_SEPARATOR } from "@flights/constants";
export const getSearchCriteria = (query, searchBoxState) => {
    const fromLocationNameSearchbox = getFromLocationFromSearchState(searchBoxState, "name");
    const toLocationNameSearchbox = getToLocationFromSearchState(searchBoxState, "name");
    const fromCountrySearchbox = getFromLocationFromSearchState(searchBoxState, "country");
    const toCountrySearchbox = getToLocationFromSearchState(searchBoxState, "country");
    return {
        fromCountry: fromCountrySearchbox,
        toCountry: toCountrySearchbox,
        fromLocationName: fromLocationNameSearchbox,
        toLocationName: toLocationNameSearchbox,
        adults: Number(query.get("adults") || 1),
        children: getQueryParamValueList("children", query)
    };
};
export const getQueryParamValueList = (paramName, query) => {
    const list = query
        .get(paramName)
        ?.split(PARAM_LIST_SEPARATOR)
        .filter((value) => value !== "");
    return list || [];
};
const getFromLocationFromSearchState = (searchBoxState, key) => {
    switch (searchBoxState.type) {
        case "MULTISTOP":
            const fromLocationName = searchBoxState.searchSegments
                .map((segment) => {
                return segment.from[0][key];
            })
                .join(MULTISTOP_IATA_LIST_SEPARATOR);
            return [fromLocationName];
        default:
            return searchBoxState.searchSegments.map((segment) => {
                return segment.from
                    .map((fromLocation) => {
                    return fromLocation[key];
                })
                    .join(PARAM_LIST_SEPARATOR);
            });
    }
};
const getToLocationFromSearchState = (searchBoxState, key) => {
    switch (searchBoxState.type) {
        case "MULTISTOP":
            const toLocationName = searchBoxState.searchSegments
                .map((segment) => {
                return segment.to[0][key];
            })
                .join(MULTISTOP_IATA_LIST_SEPARATOR);
            return [toLocationName];
        default:
            return searchBoxState.searchSegments.map((segment) => {
                return segment.to
                    .map((toLocationName) => {
                    return toLocationName[key];
                })
                    .join(PARAM_LIST_SEPARATOR);
            });
    }
};
